import { FilterOperators } from '@/shared/classes/components/data-table/data-table-filter'

export const getQueryName = (operator: FilterOperators, key: string) => {
  let queryName = `filter-${operator}`
  const parts = key.split('.')
  parts.forEach(part => queryName += `-${ part }`)

  return queryName
}
